"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Bubble = exports.List = void 0;
const stitches_config_1 = require("../../../stitches.config");
exports.List = (0, stitches_config_1.styled)("div", {
    display: "flex",
    flexWrap: "wrap",
    variants: {
        hasTooltip: {
            true: {
                width: "100%",
            },
        },
    },
});
exports.Bubble = (0, stitches_config_1.styled)("div", {
    border: stitches_config_1.borderStyles.thinGrey6,
    borderRadius: "16px",
    fontSize: stitches_config_1.fontSizes.body4,
    cursor: "pointer",
    padding: "5px 10px",
    marginRight: "10px",
    marginBottom: "7px",
    variants: {
        selected: {
            true: {
                backgroundColor: stitches_config_1.colors.bgButtonPrimary,
                color: stitches_config_1.colors.contentPrimaryDark,
                "&:hover": {
                    backgroundColor: stitches_config_1.colors.bgButtonPrimary,
                },
            },
        },
        disabled: {
            true: {
                cursor: "default",
            },
        },
        readonly: {
            true: {
                cursor: "default",
            },
        },
    },
    compoundVariants: [
        {
            selected: false,
            readonly: true,
            css: {
                opacity: "60%",
            },
        },
        {
            disabled: true,
            readonly: false,
            css: {
                opacity: "60%",
            },
        },
    ],
});
//# sourceMappingURL=data:application/json;base64,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